export default __webpack_public_path__ + "static/media/clarity.890fc026.png";